import { useEffect, useRef } from 'react';
import { extraColors } from '../stats/common';
import { LOG_STATUS_LABELS } from './logStatus';

const HOLD_MS = 550;

function colorsFor(t, c, status) {
  switch (status) {
    case 'complete': return { color: t.accent, background: t.accentSoft, border: t.accentBorder };
    case 'partial': return { color: c.amber, background: c.amberSoft, border: c.amber };
    case 'untracked': return { color: t.textMuted, background: t.badgeBg, border: t.cardBorder };
    default: return { color: t.textFaint, background: 'transparent', border: t.cardBorder };
  }
}

/* How complete the day's food log is: tap to change, hold to hand it back to
 * the automatic guess. An automatic status has a dashed border and says so,
 * so it's clear Mo hasn't set it. */
export function DayStatusChip({ t, isDark, marked, auto, onCycle, onClear }) {
  const timer = useRef(null);
  const held = useRef(false);
  useEffect(() => () => window.clearTimeout(timer.current), []);
  const status = marked || auto;
  const col = colorsFor(t, extraColors(isDark), status);

  const start = () => {
    held.current = false;
    window.clearTimeout(timer.current);
    if (!marked) return;
    timer.current = window.setTimeout(() => { held.current = true; onClear(); }, HOLD_MS);
  };
  const stop = () => window.clearTimeout(timer.current);

  return (
    <button type="button"
      title={marked ? 'Tap to change · hold to reset to automatic' : 'Tap to set how complete this day is'}
      aria-label={`Food log ${LOG_STATUS_LABELS[status] || status}${marked ? '' : ' (automatic)'}. Tap to change${marked ? ', hold to reset' : ''}.`}
      onPointerDown={start} onPointerUp={stop} onPointerLeave={stop} onPointerCancel={stop}
      onContextMenu={e => e.preventDefault()}
      onKeyDown={e => { if (marked && (e.key === 'Delete' || e.key === 'Backspace')) onClear(); }}
      onClick={() => {
        // The click that ends a hold must not also cycle.
        if (held.current) { held.current = false; return; }
        onCycle();
      }}
      style={{
        minHeight: 40, padding: '0 14px', borderRadius: 999, flexShrink: 0, cursor: 'pointer',
        color: col.color, background: col.background,
        border: `1px ${marked ? 'solid' : 'dashed'} ${col.border}`,
        fontSize: 12, fontWeight: 700, whiteSpace: 'nowrap',
        display: 'inline-flex', alignItems: 'center', gap: 6,
        userSelect: 'none', WebkitUserSelect: 'none', WebkitTouchCallout: 'none', touchAction: 'manipulation',
      }}>
      {LOG_STATUS_LABELS[status] || status}
      {!marked && <span style={{ fontWeight: 500, opacity: 0.75 }}>· auto</span>}
    </button>
  );
}
